module.exports = __webpack_public_path__ + "img/opus2.c6a00590.png";